'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _WeChat = require('./WeChat.scss');

var _WeChat2 = _interopRequireDefault(_WeChat);

var _Price = require('components/TripDetail/Price');

var _Price2 = _interopRequireDefault(_Price);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  WeChat: {
    displayName: 'WeChat'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Popup/WeChat.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var WeChat = _wrapComponent('WeChat')((_dec = (0, _reactCssModules2.default)(_WeChat2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WeChat, _Component);

  function WeChat() {
    (0, _classCallCheck3.default)(this, WeChat);
    return (0, _possibleConstructorReturn3.default)(this, (WeChat.__proto__ || (0, _getPrototypeOf2.default)(WeChat)).apply(this, arguments));
  }

  (0, _createClass3.default)(WeChat, [{
    key: 'render',
    value: function render() {
      var weChatImage = require('components/Footer/wechat.png');
      var weChatQR = require('./wechat-qr.png');
      var _props = this.props,
          isShowPrice = _props.isShowPrice,
          trip = _props.trip;

      return _react3.default.createElement(
        'div',
        { styleName: 'main-container' },
        _react3.default.createElement(
          'h2',
          null,
          '\u5BA2\u670D\u5FAE\u4FE1'
        ),
        _react3.default.createElement(
          'p',
          null,
          _react3.default.createElement('img', { src: weChatQR, styleName: 'qr' })
        ),
        isShowPrice && trip && _react3.default.createElement(_Price2.default, { trip: trip }),
        _react3.default.createElement(
          'p',
          null,
          _react3.default.createElement('img', { src: weChatImage, styleName: 'logo' }),
          _react3.default.createElement(
            'span',
            null,
            '\u5FAE\u4FE1ID: takemetour'
          )
        ),
        _react3.default.createElement(
          'h3',
          null,
          '\u5982\u60A8\u60F3\u9884\u5B9A\u6D3B\u52A8\uFF0C\u8BF7\u8054\u7CFB\u5BA2\u670D\u5FAE\u4FE1'
        )
      );
    }
  }]);
  return WeChat;
}(_react2.Component), _class2.propTypes = {
  isShowPrice: _react2.PropTypes.bool,
  trip: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = WeChat;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Popup/WeChat.js
// module id = 673
// module chunks = 47